<template>
  <ul v-if="socialLinks" class="owc-lower-footer-social">
    <li class="owc-lower-footer-social__item" v-for="(socialItem, index) in socialLinks" :key="index">
      <a
        class="owc-lower-footer-social__link"
        :href="socialItem.link.url"
        :aria-label="socialItem.iconId"
        :target="socialItem.link.target"
        data-track="false"
        @click="handleTracking(socialItem.iconId, socialItem.link.url)"
      >
        <wb-icon class="owc-lower-footer-social__icon" :name="getIcon(socialItem.iconId)"> </wb-icon>
      </a>
    </li>
  </ul>
</template>

<script lang="ts">
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import { componentMode } from './Footer.config';
import { SocialPlatform } from './Footer.enums';
import {
  SocialSectionData,
  SocialSectionMethods,
  SocialSectionComputed,
  SocialSectionProps,
} from './SocialSection';

/**
 * `SocialSection Footer` - SocialSection for OneWeb - This component contains the links for the social networks.
 */

export default ComponentInitializeDispatcher.extend<
  SocialSectionData,
  SocialSectionMethods,
  SocialSectionComputed,
  SocialSectionProps
>({
  name: 'owc-social-section',
  props: {
    socialSection: {
      type: Array,
    },
  },
  computed: {
    isEdit: function(): boolean {
      return componentMode.isEditMode;
    },
    socialLinks: function() {
      return this.isEdit ? this.componentData : this.socialSection;
    },
  },
  methods: {
    getIcon: function(iconId) {
      return SocialPlatform[iconId];
    },
    handleTracking: function(iconId, linkUrl) {
      const socialLabel = `social.${iconId}`;
      this.handleCustomTracking(this.$el, socialLabel, 'link', 'click', 'share', linkUrl);
    },
  },
});
</script>

<style lang="scss">
@import '@owc-styles/utils/rtl-utils';

$socialSectionModuleName: 'owc-lower-footer-social';

.#{$socialSectionModuleName} {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  width: 100%;
  margin-bottom: var(--wb-spacing-m);

  @include breakpoint-from(mq5) {
    flex-wrap: nowrap;
    justify-content: flex-end;
    order: 1;
    width: auto;
    margin-bottom: 0;
    margin-left: auto;
  }

  &__item {
    &:not(:last-child) {
      margin-right: var(--wb-spacing-s);
    }
  }
  &__link {
    color: var(--wb-white);
  }
  &__icon {
    pointer-events: none;
  }
}

@include rtl-rule('.owc-lower-footer-social', false) {
  &__item {
    &:not(:last-child) {
      margin-right: 0;
      margin-left: var(--wb-spacing-s);
    }
  }
}
</style>
